// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3LZH3","calendarButtons":"ClockData_calendarButtons__3Nsbi"};